import { useTheme } from "@sundae/react-hooks";
import { useMemo } from "react";
import { TasteTest } from "../../gql/generated/taste-test.sdk";
import { useHandleData, usePersonalizedHandleData } from "../../gql/hooks/handle.query";
import { getIpfsImagePath } from "../../utils/images.utils";

export interface IUseTasteTestPersonalization {
  bannerImage?: string;
  pfpImage?: string;
  primaryColor?: string;
  secondaryColor?: string;
}

export const useTasteTestPersonalization = (tasteTest: TasteTest | undefined) => {
  const { theme } = useTheme();
  const isLight = theme === "light";
  const defaultBannerImage = `/static/images/banners/banner_design_taste_test${
    isLight ? "_light" : ""
  }.png`;
  const { data: handleData, isLoading: isLoadingHandleData } = useHandleData(
    tasteTest?.adaHandle ?? ""
  );
  const { data: personalizedHandleData, isLoading: isLoadingPersonalizedHandleData } =
    usePersonalizedHandleData(tasteTest?.adaHandle ?? "");
  const isListOfBannerImages =
    Array.isArray(tasteTest?.banners) || Array.isArray(tasteTest?.banner); // `tasteTest.banner` is soon to be deprecated
  const tasteTestBannerImage = useMemo(() => {
    if (isListOfBannerImages) {
      const randomIndex = Math.floor(
        Math.random() * (tasteTest?.banners.length || tasteTest?.banner?.length || 0)
      );
      return (tasteTest?.banners || tasteTest?.banner)?.[randomIndex];
    }
    return tasteTest?.banners?.[0] || tasteTest?.banner;
  }, [isListOfBannerImages, tasteTest?.banner, tasteTest?.banners]);

  const bannerImage = handleData?.bg_image
    ? getIpfsImagePath(handleData?.bg_image)
    : tasteTestBannerImage || undefined;
  const pfpImage = handleData?.pfp_image || tasteTest?.profile || tasteTest?.asset?.logo;

  const tasteTestPersonalization: IUseTasteTestPersonalization = useMemo(() => {
    return {
      bannerImage,
      pfpImage,
      primaryColor: tasteTest?.primaryColor || undefined,
      secondaryColor: tasteTest?.secondaryColor || undefined,
    };
  }, [defaultBannerImage, personalizedHandleData, handleData, tasteTest?.asset?.logo]);

  return {
    isLoading: isLoadingHandleData || isLoadingPersonalizedHandleData,
    tasteTestPersonalization,
  };
};
